// import { apiSlice } from '../api/apiSlice'
// import 

import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const RETURN_BASE = "/return"; 
const buildUrl = (endpoint) => RETURN_BASE + endpoint;

const returnsApiSlice =  apiSlice.injectEndpoints({
    endpoints: builder => ({
        findOrderForReturn: builder.query({ 
            query: (obj) => {
                
                return ({
                    url: buildUrl(`/order/${obj.relation}/lookup`),
                    method: 'POST',
                    body: obj.body
                })
            },
            //providesTags: (obj) => [{ type: `Returns-Order-${obj.body?.ordernumber}` }]
        }),
        findShippersForReturn: builder.query({ 
            query: (obj) => {
                
                return ({
                    url: buildUrl(`/order/${obj}/shippers`),
                    method: 'GET',
                    // body: obj.body
                })
            },
            //providesTags: (obj) => [{ type: `Returns-Order-${obj.body?.ordernumber}` }]
        }),
        // portalShippers
        getReturnsToProcess: builder.query({
            query: (body) => ({
                url: buildUrl(``),
                method: 'POST',
                body,
                headers: {
                    "from_app":true
                }
            }),
            providesTags: () => [{ type: 'ReturnsToProcess' }],
        }),
        getReturnToProcessById: builder.mutation({
            query: (id) => ({
                url: buildUrl(`/${id}`),
                method: 'GET',
                headers: {
                    "from_app":true
                }
            }),
            providesTags: () => [{ type: 'ReturnToProcess' }],
        }),
        getReturnLineToProcessById: builder.mutation({
            query: ({returnId,returnLineId}) => ({
                url: buildUrl(`/${returnId}/returnlines/${returnLineId}`),
                method: 'GET',
            }),
            providesTags: () => [{ type: 'ReturnToProcess' }],
        }),
        getProductReturnLocationInfo: builder.query({
            query: (productId) => ({
                url: buildUrl(`/product-location-info/${productId}`),
                method: 'GET',
            }),
            providesTags: () => [{ type: 'ProductReturnLocationInfo' }],
        }),
        updateReturnLineProperties: builder.mutation({
            query: ({returnId,returnLineId,body}) => ({
                url: buildUrl(`/${returnId}/returnlines/updateproperties/${returnLineId}`),
                method: 'PUT',
                body,
            }),
            invalidatesTags: (result, error, arg) => [{ type: `ReturnsSingle`}],
        }),
        updateReturnLineToProcessById: builder.mutation({
            query: (body) => ({
                url: buildUrl(`/${body.returnId}/returnlines/${body.returnLineId}`),
                method: 'PUT',
                body,
            }),
            providesTags: () => [{ type: 'ReturnToProcess' }],
        }),
        
        getReturnToProcessBySearchString: builder.mutation({
            query: (searchstring) => ({
                url: buildUrl(`/find/${searchstring}`),
                method: 'GET',
                headers: {
                    "from_app":true
                }
            }),
            providesTags: () => [{ type: 'ReturnToProcess' }],
        }),
        getReturnReasonsForProcessSelect: builder.query({ 
            query: (relationId) => ({
                url: buildUrl(`/reasons/select`),
                method: 'POST',
            }),
            //providesTags: (obj) => [{ type: `Returns-Order-${obj.body?.ordernumber}` }]
        }),

        getRelationForReturn: builder.query({ 
            query: (obj) => ({
                url: buildUrl(`/order/${obj.relation}/relation`),
                method: 'GET'
            }),
            //providesTags: (obj) => [{ type: `Returns-Order-${obj.body?.ordernumber}` }]
        }),
        getOrderForReturn: builder.query({ 
            query: (obj) => ({
                url: buildUrl(`/order/${obj}/order`),
                method: 'GET'
            }),
            //providesTags: (obj) => [{ type: `Returns-Order-${obj.body?.ordernumber}` }]
        }),
        createReturnForReturn: builder.mutation({
            query: (obj) => ({
                url: buildUrl(`/order/${obj.relation}/create`),
                method: 'POST',
                body: obj.body,
            }),
        }),
        createReturn: builder.mutation({
            query: (body) => ({
                url: buildUrl(`/order`),
                method: 'POST',
                body
            }),

        }),
        createReturnLabel: builder.mutation({
            query: (body) => ({
                url: buildUrl(`/label`),
                method: 'POST',
                body
            }),
            invalidatesTags: () => [{ type: 'Returns' }],
        }),
        getFinalize: builder.query({ 
            query: (obj) => ({
                url: buildUrl(`/order/${obj.relation}/finalize`),
                method: 'GET'
            }),

        }),
        getStatus: builder.query({ 
            query: (obj) => ({
                url: buildUrl(`/order/${obj}/status`),
                method: 'GET'
            }),

        }),
        getReturnLabel: builder.mutation({ 
            query: ({relation,shipmentId}) => ({
                url: buildUrl(`/order/${relation}/label/${shipmentId}`),
                method: 'GET'
            }),

        }),
        findUrlForReturn: builder.query({
            query: (id) => {
                return ({
                    url: buildUrl(`/order/${id}/link`),
                    method: 'GET'

                })
            }
            //providesTags: (obj) => [{ type: `Returns-Order-${obj.body?.ordernumber}` }]
        }),
        getReturnPhotos: builder.query({
            query: (returnId) => ({
                url: buildUrl(`/${returnId}/photos`),
                method: 'GET',
            }),
            providesTags: (result, error, returnId) => [
                { type: 'ReturnPhotos', id: `${returnId}` }
            ],
        }),
        getReturnLinePhotos: builder.query({
            query: ({returnId, returnLineId}) => ({
                url: buildUrl(`/${returnId}/returnlines/${returnLineId}/photos`),
                method: 'GET',
            }),
            providesTags: (result, error, {returnId, returnLineId}) => [
                { type: 'ReturnLinePhotos', id: `${returnId}-${returnLineId}` }
            ],
        }),
        uploadReturnLinePhoto: builder.mutation({
            query: ({returnId, returnLineId, file}) => {
                const formData = new FormData();
                formData.append('file', file);
                return {
                    url: buildUrl(`/${returnId}/returnlines/${returnLineId}/photos`),
                    method: 'POST',
                    body: formData,
                };
            },
            invalidatesTags: (result, error, {returnId, returnLineId}) => [
                { type: 'ReturnLinePhotos', id: `${returnId}-${returnLineId}` }
            ],
        }),
        deleteReturnLinePhoto: builder.mutation({
            query: ({returnId, returnLineId, photoId}) => ({
                url: buildUrl(`/${returnId}/returnlines/${returnLineId}/photos/${photoId}`),
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, {returnId, returnLineId}) => [
                { type: 'ReturnLinePhotos', id: `${returnId}-${returnLineId}` }
            ],
        }),
    })
});

export const {
    useFindShippersForReturnQuery,
    useFindOrderForReturnQuery,
    // useFindOrderForReturnMutation,
    // useFindOrderForReturnQuery,
    useGetRelationForReturnQuery,
    useGetOrderForReturnQuery,
    useCreateReturnForReturnMutation,
    useCreateReturnMutation,
    useCreateReturnLabelMutation,
    useGetFinalizeQuery,
    useGetStatusQuery,
    useGetReturnLabelMutation,
    useGetReturnsToProcessQuery,
    useGetReturnToProcessByIdMutation,
    useGetReturnToProcessBySearchStringMutation,
    useGetReturnLineToProcessByIdMutation,
    useGetProductReturnLocationInfoQuery,
    useGetReturnReasonsForProcessSelectQuery,
    useUpdateReturnLineToProcessByIdMutation,
    useFindUrlForReturnQuery,
    useGetReturnPhotosQuery,
    useGetReturnLinePhotosQuery,
    useUploadReturnLinePhotoMutation,
    useDeleteReturnLinePhotoMutation,
    useUpdateReturnLinePropertiesMutation,
  } = returnsApiSlice;

